export enum KeyboardKeyCodes {
    C = 67,
    F = 70,
    M = 77,
    P = 80,
    R = 82,
    S = 83,
    V = 86
}